import React, { useContext } from 'react'
import { FileContext } from '../../Context'
import ApplicantsItems from './Items'
import { useStyles } from './Style'

const Applicants: React.FC = (): React.ReactElement => {
  const classes = useStyles()
  const { application, applicants } = useContext(FileContext)

  if (!application || !applicants.list) {
    return <></>
  }

  return (
    <div className={classes.wrapper}>
      <div className={classes.container}>
        {applicants.list.map((applicant) => (
          <ApplicantsItems key={applicant.id} applicantId={applicant.id} />
        ))}
      </div>
    </div>
  )
}

export default Applicants
